import { supabase } from '../../lib/supabaseClient';

export type MerchItem = {
  id: string;
  title_en: string;
  title_th: string | null;
  shopify_url: string;
  image_url: string | null;
  sort_order: number;
  created_at?: string;
  updated_at?: string;
};

export async function getMerchItems() {
  const { data, error } = await supabase
    .from('merch_items')
    .select('*')
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return (data ?? []) as MerchItem[];
}

export async function createMerchItem(payload: Partial<MerchItem>) {
  const { data, error } = await supabase.from('merch_items').insert(payload).select('id').single();
  if (error) throw error;
  return data.id as string;
}

export async function updateMerchItem(id: string, payload: Partial<MerchItem>) {
  const { error } = await supabase.from('merch_items').update(payload).eq('id', id);
  if (error) throw error;
}

export async function deleteMerchItem(id: string) {
  const { error } = await supabase.from('merch_items').delete().eq('id', id);
  if (error) throw error;
}
